var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: '100%'})},[_c('ceshi')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }